/**
 * Checks wether the given `value` implements the interface [[StepOffset]].
 *
 * @param value The value to be checked
 * @returns {boolean} True if the given value implements [[StepOffset]] and false otherwise
 */
export function isStepOffset(value) {
    return value.hasOwnProperty('stepOffset');
}
//# sourceMappingURL=step-offset.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-archwizard/dist/components/util/step-offset.interface.js
// module id = 485
// module chunks = 4